import React, { useEffect } from "react";
import {
  useMount,
  useUnmount,
  useSafeState,
  useUpdateEffect,
  useSetState,
} from "ahooks";
import dayjs from "dayjs";
import md5 from "md5";
import * as singleSpa from "single-spa";
const SystemJs = window["System"];
import { mapAppConfigDatas, menuDatas, sonAppDatas } from "@/config";
import useSearchJson from "@/hooks/useSearchJson.js";
import { Skeleton, Button, Result } from "antd";

const useMainfest = () => {
  const [data, setData] = useSafeState();
  const [loading, setLoading] = useSafeState(false);
  const run = async (url) => {
    setLoading(true);
    try {
      let res = await fetch(url, {});
      let json = await res.json();
      setData(json);
    } catch (e) {
      setData(null);
    }
    setLoading(false);
  };
  return [data, run, loading];
};

export default (props) => {
  const { activitySonApp, onMounted } = props;
  const { appAssetDir, appBasicPath, id: appMoutDomId } = activitySonApp || {};
  const { refresh = dayjs().format("YYYYMMDDHHmmss") } = useSearchJson();

  const getDomById = () => document.getElementById(activitySonApp?.id);
  const [appMoutDom, setAppMoutDom] = useSafeState(getDomById);
  const [mainfest, setMainfest, loading] = useMainfest();

  useEffect(() => {
    setAppMoutDom(getDomById());
    const mainfestUrl = `${window["Web_Host"]}/${appAssetDir}/manifest.json?r=${refresh}`;
    setMainfest(mainfestUrl);
  }, [activitySonApp, refresh]);

  const createDt = mainfest?.createDt
    ? dayjs(mainfest["createDt"]).format("YYYYMMDDHHmmss")
    : dayjs().format("YYYYMMDDHHmmss");

  const [loadAppUrl, setLoadAppUrl] = useSafeState();
  useEffect(() => {
    if (!mainfest) {
      return;
    } else {
      const indexJs = mainfest["index.js"];

      const url = `${window.Web_Host}/${indexJs}?dt=${md5(createDt)}`;
      setLoadAppUrl(url);
    }
  }, [mainfest]);

  useEffect(() => {
    const appName = appMoutDomId;
    // const appNames = singleSpa.getAppNames();
    sonAppDatas.forEach((item) => {
      if (item.id !== appMoutDomId) {
        try {
          singleSpa.unloadApplication(item.id);
          // if ([...appNames].includes(item.id)) {
          //   console.log(`移除应用.${item.id}`, item.appAssetDir);
          // }
        } catch (e) {}
      }
    });
    if (!loadAppUrl) {
      return;
    }
    if (!mainfest) {
      return;
    }

    const nextProps = {
      createDt,
      appBasicPath,
      appMoutDomId,
      mainfestData: mainfest,
      onMounted,
    };

    console.log(`挂载应用.${appMoutDomId}`, appAssetDir);
    try {
      singleSpa.registerApplication(
        appName,
        SystemJs.import(loadAppUrl),
        (location) => {
          let targetPathname = location.pathname;
          const regStr = `^${appBasicPath}(\/.*)?$`;
          return new RegExp(regStr).test(targetPathname);
          // let targetPathname = location.pathname;
          // if (
          //   new RegExp(`^${appBasicPath}$`).test(targetPathname) ||
          //   new RegExp(`^${appBasicPath}\/`).test(targetPathname)
          // ) {
          //   return true;
          // } else {
          //   return false;
          // }
        },
        {
          ...nextProps,
        }
      );
      singleSpa.start();
    } catch (e) {
      // console.log("加载子应用失败", e);
    }
  }, [loadAppUrl]);

  if (mainfest && !mainfest["index.js"]) {
    return (
      <Result
        subTitle={"!indexJs"}
        extra={
          <Button
            type="primary"
            onClick={(e) => {
              singleSpa.navigateToUrl("/");
            }}
          >
            Back Home
          </Button>
        }
      />
    );
  }
  return <></>;
};
